export default __webpack_public_path__ + "locales/vi/Files.json?hash=820faf12b2d4de2d20553e6622cd0fbd";